/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md:
   this file exports a function, not a React component. */
// Own-property read, and `=== true` so an inherited Object.prototype method never reads as truthy.
export function readOwnFlag(
  flagsByKey: Readonly<Record<string, boolean>> | undefined,
  key: string,
): boolean {
  if (flagsByKey === undefined) return false;
  return Object.hasOwn(flagsByKey, key) && flagsByKey[key] === true;
}
